import { TravellerType, SortOrder } from "@/lib/Types/ReviewsResponse/ReviewsResponse";

export const travellerTypeOptions = [
  { value: "ALL", label: "Alle" },
  { value: "PAAR", label: "Paar" },
  { value: "FAMILIE", label: "Familie" },
  { value: "FREUNDE", label: "Freunde" },
  { value: "SINGLE", label: "Single" },
];

export const sortTypeOptions = [
  { value: "newest", label: "Neueste" },
  { value: "best", label: "Beste" },
  { value: "worst", label: "Schlechteste" },
  { value: "month", label: "Reisemonat" },
];

export const ALL_TRAVELLER_TYPES: TravellerType[] = [
  "PAAR",
  "FAMILIE",
  "FREUNDE",
  "SINGLE",
];

export const sortMapping: Record<string, { sort: string; sortOrder: SortOrder }> = {
  newest: { sort: "DATE_RATING", sortOrder: "desc" },
  best: { sort: "RATING", sortOrder: "desc" },
  worst: { sort: "RATING", sortOrder: "asc" },
  month: { sort: "TRAVEL_DATE", sortOrder: "desc" },
};
